import { render, staticRenderFns } from "./CategoriesCard.ts.vue?vue&type=template&id=614c1b7e"
import script from "./CategoriesCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoriesCard.ts.vue?vue&type=style&index=0&id=614c1b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports